import { useApplicationModals } from "app/common/hooks";
import { useEffect } from "react";
import { useDeleteForm } from "app/integration/common/hooks";
import * as Yup from "yup";
import api from "app/integration/api";
import { ModalMolecule } from "app/components/molecules/modal";
import { Formik } from "formik";
import { Button } from "app/components/atoms/button";
import AppModals from ".";

function DeleteInvoiceModal({ onSuccess = (response) => {} }) {
  const { showStates, getPayloads, closeModal } = useApplicationModals();
  const payload = getPayloads("invoice.delete");

  var isError = false;

  const handleClose = () => closeModal("invoice.delete");
  const handleSuccess = () => {
    closeModal("invoice.delete");
    onSuccess();
  };

  const { openModal, setPayloads } = useApplicationModals();

  const { initialValues, setInitialValues, validationSchema, onSubmit } =
    useDeleteForm({
      initialValues: {
        id: payload.id,
      },
      validationSchema: Yup.object().shape({
        id: Yup.number().required("Id diperlukan"),
      }),
      onSubmit: async (values) => {
        try {
          await api.invoice.delete(values.id);
          isError = false;
        } catch (error) {
          setPayloads("errorMessage.view", {
            title: "Delete Invoice Error",
            message:
              error?.response.status === 400
                ? "Gagal delete invoice karena invoice telah dibayar. Harap menghapus pembayaran terlebih dahulu dengan menghubungi admin."
                : error?.response?.data?.message,
          });
          isError = true;
          openModal("errorMessage.view");
          // console.log("delete error: ", error?.response?.data?.message);
        }
      },
      onSuccess: () => {
        if (!isError) {
          handleSuccess();
        }
      },
    });

  useEffect(() => {
    setInitialValues({ id: payload.id });
  }, [payload.id]);

  return (
    <ModalMolecule
      show={showStates["invoice.delete"]}
      title="Hapus Invoice"
      onClose={handleClose}
    >
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            Apakah Anda yakin ingin menghapus Invoice?
            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button type="submit">Hapus Invoice</Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}

export default DeleteInvoiceModal;
